import React, { useEffect } from 'react';
import { trackSessaoAutocuidadoClick } from '../analytics';

export default function SessaoAutocuidadoRedirect() {
   useEffect(() => {
      // Get the source from URL query parameters
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get('source') || urlParams.get('utm_source') || 'direct';
      
      // Track the event with source
      trackSessaoAutocuidadoClick(source);
      
      // Redirect to WhatsApp after a brief delay to ensure analytics event is sent
      const timer = setTimeout(() => {
         window.location.href = 'https://api.whatsapp.com/send?phone=19439901079&text=Oi!%20Tenho%20interesse%20no%20Pacote%20de%20Autocuidado%20para%20lidar%20com%20a%20exaust%C3%A3o%20no%20fim%20do%20dia.%20Pode%20me%20explicar%20como%20funciona%3F';
      }, 300); // 300ms delay to ensure analytics event is tracked

      return () => clearTimeout(timer);
   }, []);

   return (
      <div style={{ 
         display: 'flex', 
         justifyContent: 'center', 
         alignItems: 'center', 
         height: '100vh',
         fontSize: '1.2rem',
         color: '#666'
      }}>
         {/* Redirecionando... */}
      </div>
   );
}
